import React from 'react';
import PropTypes from 'prop-types';
import './Slider.css';

/**
 * Slider - Standardized range slider component
 */
const Slider = ({
  id,
  name,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  disabled = false,
  required = false,
  showValue = true,
  showLabels = false,
  minLabel,
  maxLabel,
  className = '',
}) => {
  const percentage = ((value - min) / (max - min)) * 100;

  return (
    <div className={`ml-slider ${className}`}>
      <div className="ml-slider__track-container">
        <input
          id={id}
          name={name}
          type="range"
          value={value}
          onChange={onChange}
          min={min}
          max={max}
          step={step}
          disabled={disabled}
          required={required}
          className="ml-slider__control"
          style={{
            background: `linear-gradient(to right, var(--c-accent) 0%, var(--c-accent) ${percentage}%, var(--c-surface-alt) ${percentage}%, var(--c-surface-alt) 100%)`,
          }}
        />
        {showValue && <span className="ml-slider__value">{value}</span>}
      </div>
      {showLabels && (minLabel || maxLabel) && (
        <div className="ml-slider__labels">
          <span className="ml-slider__label-min">{minLabel || min}</span>
          <span className="ml-slider__label-max">{maxLabel || max}</span>
        </div>
      )}
    </div>
  );
};

Slider.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  showValue: PropTypes.bool,
  showLabels: PropTypes.bool,
  minLabel: PropTypes.string,
  maxLabel: PropTypes.string,
  className: PropTypes.string,
};

export default Slider;
